import { gql } from "@apollo/client";

export type OnboardingStatusData = {
  getBranches: { id: string }[];
  getProductCount: number;
  getPartner: {
    id: string;
    logo: string | null;
    short_desc: string | null;
  };
  getConnectAccount: {
    id: string;
    status: string;
  } | null;
};

export const GET_ONBOARDING_STATUS = gql`
  query GetOnboardingStatus {
    getBranches {
      id
    }
    getProductCount
    getPartner {
      id
      logo
      short_desc
    }
    getConnectAccount {
      id
      status
    }
  }
`;
